import React from 'react'
import Flag from '../common/Flag'

export default function Startlist({ startlist }) {
  if (!startlist || !startlist.jumpers || startlist.jumpers.length === 0) {
    return (
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 text-center">
        <p className="text-gray-700">
          The startlist will be displayed here as soon as the list is generated at the Team Captains Meeting
        </p>
      </div>
    )
  }

  return (
    <div className="overflow-x-auto">
      <table className="resultstable w-full">
        <thead>
          <tr>
            <th className="w-16"></th>
            <th className="text-center w-16">Bib</th>
            <th>Name</th>
            <th className="w-16">Nat.</th>
          </tr>
        </thead>
        <tbody>
          {startlist.jumpers.map((row, index) => (
            <tr key={index} className={index % 2 === 0 ? 'even' : 'odd'}>
              <td className="text-center">
                <img
                  src={row.image || '/images/hill.png'}
                  width="32"
                  alt={`${row.firstname} ${row.lastname}`}
                  onError={(e) => { e.target.src = '/images/hill.png' }}
                />
              </td>
              <td className="text-center">{row.bib}</td>
              <td>{row.lastname}, {row.firstname}</td>
              <td>
                <Flag code={row.nat} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
